import PatientSelect from './PatientSelect';
import PatientSelectUI from './PatientSelectUI';

export default PatientSelect;

export { PatientSelectUI };
